import { gql } from '@apollo/client'

export const UPDATE_CATEGORY = gql`
  mutation updateCategory($input: UpdateCategoryInput!) {
    data: updateCategory(input: $input) {
      id
    }
  }
`
